import React, { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";

import Menu from "./componentes/Menu/Menu";
import Home from "./pages/Home/Home";

import useScrollReveal from "./useScrollReveal";
import Footer from "./pages/Footer/Footer";

function AppContent() {
  const location = useLocation();

  useScrollReveal([location.pathname]);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;

      const el = document.getElementById(id);

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  
  return (
    <>
      <Menu />

      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>

      {/* <Footer /> */}
    </>
  );
}

export default AppContent;
